import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AnnotationsPdfService {
  $currentPage: BehaviorSubject<number> = new BehaviorSubject<number>(-1);
  pdfLoaded = false;

  loaded() {
    this.pdfLoaded = true;
    return this.pdfLoaded;
  }

  updateCurrentPage(pageNumber: number) {
    this.$currentPage.next(pageNumber);
  }

  $getCurrentPage(): Observable<number> {
    return this.$currentPage.asObservable();
  }
}
